<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            <h1 class="page-title-accessibility">Void Checks</h1>
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="w-100">
                    <form nz-form [formGroup]="filterForm" (ngSubmit)="onSearch()">
                        <div nz-row [nzGutter]="16" class="filter-row">
                            <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="5">
                                <label for="providerPplId" class="field-header">Provider PPL ID</label>
                                <input nz-input id="providerPplId" formControlName="providerPplId" placeholder="Provider PPL ID" />
                            </div>
                            <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="5">
                                <label for="chequeNumber" class="field-header">Check #</label>
                                <input nz-input id="chequeNumber" formControlName="chequeNumber" placeholder="Check #" />
                            </div>
                            <div nz-col class="filter-actions">
                                <ppl-button label="Search" icon="fa fa-search" [customClass]="'primary-button'"
                                    [iconPosition]="'left'" (click)="onSearch()"></ppl-button>
                                <ppl-button label="Clear" [customClass]="'ghost-button'" (click)="onClear()"></ppl-button>
                            </div>
                        </div>
                        @if (showRequiredError) {
                        <div class="error-message">Please enter a Provider PPL ID or a Check #.</div>
                        }
                    </form>
                    <p><strong>Note:</strong></p>
                    <ul>
                        <li>Use this page for cheques that were voided and unapplied in NAV.</li>
                        <li><strong>Void Check</strong> marks all timesheet and invoice lines paid by the cheque as
                            reversed and gives the authorization back. Select one cheque at a time.</li>
                    </ul>
                </div>
                <div class="table-style">
                    @if (hasSearched) {
                    <ppl-list-table [cols]="cols" [disableSort]="true" [disableSearch]="true" [showCustomSearch]="false"
                        [data]="cheques" [customDataLoaded]="true" [enableActions]="false"
                        [gridTitle]="false" [pagination]="true" [loadPage]="true" (onPageLoad)="onPageLoad($event)"
                        [actionButtons]="actionButtons" [enablePageActions]="!isReadOnly"
                        [showExpandIcon]="true" [showLineItem]="true" [lineItemCols]="lineItemCols"
                        [showLineItemActions]="false" (rowDetailEvent)="rowClicked($event)"
                        [listButton]="isReadOnly ? [] : buttons" (actionInvoked)="gridAction($event)">
                    </ppl-list-table>
                    } @else {
                    <div class="alert alert-warning">Search by Provider PPL ID or Check # to see cheques.</div>
                    }
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ppl-popup-dialog [(isVisible)]="showVoidPopup" title="Void Check" isOkText="Void Check"
    (confirm)="submitVoid()" (cancel)="cancelVoid()" [showButtons]="true" [showOkButton]="false"
    [size]="'medium'" [position]="'center'">
    <form nz-form [formGroup]="voidForm">
        @if (selectedCheque) {
        <p>Cheque <strong>{{ selectedCheque.chequeNumber }}</strong> for provider
            <strong>{{ selectedCheque.providerId }}</strong> will be voided, and its
            {{ selectedCheque.paidLineCount ?? '' }} paid line(s) will be reversed. This cannot be undone.</p>
        }
        <nz-form-item>
            <nz-form-control>
                <label for="voidReason" class="field-header">Reason <span class="error-message1">*</span></label>
                <nz-textarea-count [nzMaxCharacterCount]="REASON_MAX_LENGTH">
                    <textarea rows="3" nz-input id="voidReason" formControlName="reasonCode"
                        placeholder="e.g. NAV check voided and unapplied" [maxlength]="REASON_MAX_LENGTH"
                        [nzStatus]="voidForm.get('reasonCode')?.invalid && voidForm.get('reasonCode')?.touched ? 'error' : ''"></textarea>
                </nz-textarea-count>
                @if (voidForm.get('reasonCode')?.invalid && voidForm.get('reasonCode')?.touched) {
                <div class="error-message">Please enter a reason.</div>
                }
            </nz-form-control>
        </nz-form-item>
    </form>
</ppl-popup-dialog>
